import { Grid } from '@material-ui/core';
import React, {useEffect, useState} from 'react';
import {useQueryClient} from "react-query";
import __ from "lodash";

import { ConvertedNumber, FormDialog }from "../../../controls";
import { MaskedNumber } from '../../../controls';
import { fetch as fetchUnitsOfMeasure } from '../../../services/settings/useUnitsOfMeasure';
import UomLookup from '../../Settings/components/UomLookup';
import Validator from "../validators/AircraftFuelUpliftValidator";
import NumberFormat from 'react-number-format';

const AircraftFuelUpliftDialog = (props) => {

  const classes = props.classes;
  const SystemData = props.systemData;
  const queryClient = useQueryClient();
  const eventBus = SystemData.eventBus;

  let uomData = null;
  fetchUnitsOfMeasure({
    queryClient,
    useCache: true,
    extraKeys: [],
  }).then(data => {
    uomData = data;
  });

  const [dialogState, setDialogState] = useState({
    showDialog: false,
    canEdit: false,
    title: 'Uplifted Aircraft Fuel',
    record: {
      upliftFuelQty: 0,
      upliftFuelUom: '',
      upliftFuelUsg: 0,
      usgConversionFactor: 1
    }
  });

  const USGtoKG = (props) => {

    const value = props.value;
    let uomRecord = __.find(uomData, {    
      uomCode: 'KG',
      toUomCode: "USG",
    });
    const convertedValue = value / (uomRecord?.factor||1);
    return (
      <NumberFormat
        value={convertedValue}
        decimalScale={0}
        fixedDecimalScale={true}
        thousandSeparator=","
        decimalSeparator="."
        thousandsGroupStyle="thousand"
        style={{fontSize: "0.875rem", ...props.style}}
        type="text"
        displayType="text"
      />
    )
  }

  const handleQtyChange = (qty, props) => {
    const {record, recordChange} = props;

    let uomRecord = __.find(uomData, {    
      uomCode: record?.upliftFuelUom||'',
      toUomCode: "USG",
    })

    const usgConversionFactor = record.upliftFuelUom?uomRecord?.factor||record.usgConversionFactor||1:0;
    const upliftFuelQty = qty||0;
    const upliftFuelUsg = (upliftFuelQty||0) * usgConversionFactor;
    recordChange({...record, upliftFuelQty, usgConversionFactor, upliftFuelUsg });
  }

  const handleUomChange = (uom, props) => {
    const {record, recordChange} = props;
    if (uom.found) {
      const upliftFuelUsg = (record.upliftFuelQty||0) * uom.data.factor;
      recordChange({...record, upliftFuelUom: uom.value, usgConversionFactor: uom.data.factor, upliftFuelUsg });
    } else {
      if (typeof uom === "object") {
        recordChange({...record, upliftFuelUom: uom.value});
      } else {
        recordChange({...record, upliftFuelUom: uom});
      }
    }
  }

  const DisplayForm = () => {

    return (
      <FormDialog
        title={dialogState.title}
        zIndex={1301}
        message=""
        open={dialogState.showDialog}
        record={dialogState.record}
        dialogOptions={{maxWidth: "sm", fullWidth: false}}
        classes={classes}
        validator={Validator}
        buttons = {{
          save:{icon: "check_circle", key: "Update", label: "Update", color: "primary", disabled: (status)=>{return status.error}},
          cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
        }}
        onChange={(state) => {
          if (state.buttonPressed === "save") {
            const record = state.record;
            props.onChange(record);
            setDialogState({...dialogState, showDialog: false, record: null, handleSave: null});
          } else {
            setDialogState({...dialogState, showDialog: false, record: null, handleSave: null});
          }
        }}
      >
        <div style={{display: "inline-block", width: 200}} checkChildren={true}>
          <Grid
            container
            direction="row"
            justify="flex-end"
            checkChildren={true}
            spacing={3}
          >
            <Grid item xs style={{ minWidth:70 }} checkChildren={true}>
              <MaskedNumber
                id="upliftFuelQty"
                decimalScale={0}
                fixedDecimalScale={true}
                style={{fontSize: "0.875rem", ...props.style}}
                onChange={handleQtyChange}
              />
            </Grid>
            <Grid item xs style={{ minWidth:55 }} checkChildren={true}>
              <UomLookup
                id="upliftFuelUom"
                returnType={"object"}
                onChange={handleUomChange}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justify="flex-end"
            checkChildren={true}
            spacing={3}
          >
            <Grid item xs style={{ minWidth:70 }} checkChildren={true}>
              <NumberFormat
                id="upliftFuelUsg"
                decimalScale={0}
                fixedDecimalScale={true}
                thousandSeparator=","
                decimalSeparator="."
                thousandsGroupStyle="thousand"
                style={{fontSize: "0.875rem", ...props.style}}
                type="text"
                displayType="text"
              />
            </Grid>
            <Grid item xs style={{ minWidth:55, fontSize: "0.875rem", ...props.style}}>
              USG
            </Grid>
          </Grid>          
          <Grid
            container
            direction="row"
            justify="flex-end"
            checkChildren={true}
            spacing={3}
          >
            <Grid item xs style={{ minWidth:70 }} checkChildren={true}>
              <USGtoKG 
                id="upliftFuelUsg"
              />
            </Grid>
            <Grid item xs style={{ minWidth:55, fontSize: "0.875rem", ...props.style}}>
              KG
            </Grid>
          </Grid>
        </div>
      </FormDialog>
    )
  }

  useEffect(()=> {
    const open = async (params) => {
      //TODO: tripLegUuid should be primaryObjectUuid as it can be either tripLegUuid or tripUuid
      const {title, canEdit, record} = params;
      setDialogState({...dialogState, showDialog:true, canEdit, title, record});
    }
    eventBus.bind("AircraftFuelUpliftDialog.open", open);
    return () => {
      eventBus.unbind("AircraftFuelUpliftDialog.open", open);
    }
  }, [dialogState, eventBus, queryClient]);

  if (dialogState.showDialog) {
    return (
      <DisplayForm />
    )
  }
  return (<></>);
}

export default AircraftFuelUpliftDialog;
